"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDispenserInfo = getDispenserInfo;
const utils_1 = require("../../utils");
/**
 *
 * Returns information regarding the given liquid governance dispenser.
 *
 * @param indexerClient - Algorand indexer client to query
 * @param dispenser - dispenser to query about
 * @returns DispenserInfo[] dispenser info
 */
function getDispenserInfo(indexerClient, dispenser) {
    return __awaiter(this, void 0, void 0, function* () {
        const { appId } = dispenser;
        const res = yield indexerClient.lookupApplications(appId).do();
        const state = res["application"]["params"]["global-state"];
        const distributorAppIds = (0, utils_1.parseUint64s)(String((0, utils_1.getParsedValueFromState)(state, "distribs"))).map((appId) => Number(appId));
        const isMintingPaused = Boolean((0, utils_1.getParsedValueFromState)(state, "is_minting_paused") || 0);
        return {
            currentRound: res["current-round"],
            distributorAppIds,
            isMintingPaused,
        };
    });
}
//# sourceMappingURL=governance.js.map